import { Architecture, Calculate, Inventory } from '@mui/icons-material'
import MapIcon from '@mui/icons-material/Map'
import AssemblyIcon from 'src/assets/icons/assemblyIcon.svg?react'
import ExportIcon from 'src/assets/icons/exportIcon.svg?react'
import IFCIcon from 'src/assets/icons/ifc_icon.svg?react'
import LoadsIcon from 'src/assets/icons/loadsIcon.svg?react'
import StructuralPlateIcon from 'src/assets/icons/structuralIcon.svg?react'

export const usageClassOptions = [
  {
    value: 'One',
    label: 'NKL 1',
  },
  {
    value: 'Two',
    label: 'NKL 2',
  },
  {
    value: 'Three',
    label: 'NKL 3',
  },
]

export const navigationConfig = [
  {
    label: 'Aufbau Auswahl',
    route: (id: string) => `/editor/${id}/manager`,
    icon: AssemblyIcon,
  },
  {
    label: 'IFC Import',
    route: (id: string) => `/editor/${id}/ifc-import`,
    icon: IFCIcon,
  },
  {
    label: 'Globale Lasten',
    route: (id: string) => `/editor/${id}/global-loads`,
    icon: LoadsIcon,
  },
  {
    label: 'Tragwerksplanung',
    route: (id: string) => `/editor/${id}/structural-planning`,
    icon: StructuralPlateIcon,
  },
  {
    label: 'Ergebnisse',
    route: (id: string) => `/editor/${id}/results`,
    icon: Calculate,
  },
  {
    label: 'Pläne',
    route: (id: string) => `/editor/${id}/plan-view`,
    icon: Architecture,
  },
  {
    label: 'Dokumentation',
    route: (id: string) => `/editor/${id}/export`,
    icon: ExportIcon,
  },
  {
    label: 'Dokumentenmanager',
    route: (id: string) => `/editor/${id}/document-manager`,
    icon: Inventory,
  },
  {
    label: 'Pläne (alt)',
    route: (id: string) => `/editor/${id}/plans`,
    icon: MapIcon,
    // Hidden while the `disableOldPlans` app setting is on (superseded by the new "Pläne" page).
    isOldPlansPage: true,
  },
]
